import { computed, Ref } from '@vue/composition-api';
import { AdgroupFormData, AppIOSType } from '@tt4b/ttam-enums';
import { NetStateEnum, useStore } from '@tt4b/ttam-hooks';

export function useSelectedApp(options: { adgroupData: Ref<AdgroupFormData>; appId?: string }) {
  const { adgroupData, appId } = options;
  const { state, getStore } = useStore();
  const { data: appList } = getStore(NetStateEnum.promotionAppList);
  const aadvid = computed(() => state.baseInfo.value.aadvid);

  const selectedAppObj = computed(() => appList.value?.find(app => app.Id === (appId ?? adgroupData.value.adRefAppId)));

  const isPermittedApp = computed(() => selectedAppObj.value?.AccountAppVerifiedState === AppIOSType.PERMITTED);

  const isFrozenApp = computed(() =>
    [AppIOSType.PROBATED, AppIOSType.BLOCKED_CONFLICT_APP_ACCOUNT, AppIOSType.BLOCKED_UNSUPPORTED_MMP].includes(
      selectedAppObj.value?.AccountAppVerifiedState
    )
  );

  const eventManagerUrl = computed(() =>
    (selectedAppObj.value?.AppId ?
      `/i18n/events_manager/app/detail/${selectedAppObj.value.AppId}?aadvid=${aadvid.value}` :
      `/i18n/events_manager/app?aadvid=${aadvid.value}`)
  );

  const appName = computed(() => selectedAppObj.value?.AppName ?? '');

  return {
    selectedAppObj,
    appName,
    isFrozenApp,
    isPermittedApp,
    eventManagerUrl,
  };
}
